export const GITHUB_URL = 'https://github.com/tlhabane/wisperisp';
export const APP_NAME = 'Private Sector Workers Trade Union';
export const STORAGE_KEY = 'pswtu';
export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
